import { createRoot } from "react-dom/client";
import { createInertiaApp } from "@inertiajs/react";
import * as Sentry from "@sentry/react";
import CmsLayout from "../layout/Layout";
import { SentryUtil } from "../utils/sentry";
import ErrorBoundaryHandler from "../utils/sentry/ErrorBoundaryHandler";
import { onBoundaryError } from "../utils/sentry/onBoundaryError";
import type { ReactNode } from "react";

import "../styles/cms.css";

SentryUtil.init();

// Temporary type definition, until @inertiajs/react provides one
interface ResolvedComponent {
  default: ReactNode;
  layout?: (page: ReactNode) => ReactNode;
}

const pages = import.meta.glob<ResolvedComponent>(["../pages/**/*.jsx", "../pages/**/*.tsx"]) as Record<string, any>;
console.log("PAGES", pages);

document.addEventListener("DOMContentLoaded", () => {
  createInertiaApp({
    resolve: async (name: string) => {
      console.log("NAME", name);

      const __page = pages[`../pages/${name}/index.jsx`] || pages[`../pages/${name}/index.tsx`];
      console.log("__PAGE", __page);

      return Promise.resolve(__page())
        .then((_page) => {
          console.log("_page", _page);
          if (!_page) {
            throw new Error(`Page not found: ${name}`);
          }

          let page = _page;
          page = page && "default" in page ? page.default : page;

          if (page) {
            page.layout = page.layout || CmsLayout;
            return page;
          } else {
            console.error(`Page component not found for ${name}`);
          }
        })
        .catch((e) => {
          console.warn("Error resolving page component:");
          console.error(e);
        });
    },

    setup({ el, App, props }) {
      console.log("application.tsx - render App", {
        el,
        App,
        props: props.initialPage.props,
      });

      createRoot(el!).render(
        <Sentry.ErrorBoundary fallback={<ErrorBoundaryHandler />} onError={onBoundaryError}>
          <App {...props} />
        </Sentry.ErrorBoundary>,
      );
    },
  }).catch((error: unknown) => {
    console.warn("Error creating Inertia app:");
    console.error(error);
  });
});
